import { DNA } from '../visual-language'

export function calcLineHeight({
  fontSize,
  lineHeight,
}: {
  fontSize: string
  lineHeight: number
}) {
  return `calc(${fontSize} * ${lineHeight})`
}

export const makeTokenStyles = <T, Y>(tokens: T, cssPropFnMap: Y) =>
  Object.entries(tokens).reduce(
    (obj, [key, val]) => ({
      ...obj,
      [key]: Object.entries(cssPropFnMap).reduce(
        (styles, [prop, fn]) => ({
          ...styles,
          [prop]: fn(key, val),
        }),
        {}
      ),
    }),
    {}
  ) as { [K in keyof T]: { [X in keyof Y]: String } }

export const spaceWithScale = (s: keyof typeof DNA.tokens.dimension.size) =>
  `calc(${DNA.tokens.dimension.scaleMultiplier} * ${DNA.tokens.dimension.size[s]})`
